// extracted by mini-css-extract-plugin
export default {"videoEmbed":"VKErKx","player":"DeC86S","thumbnail":"Ck4CbT","overlay":"hY1SDT","button":"SBxzc1","arrow":"yZdBM6","icon":"oalSDP"};